import UploadedDocuments from './UploadedDocuments';

export default UploadedDocuments;
